





































	/* eslint-disable @typescript-eslint/camelcase */ 

	import {Prop, Watch, Component, Vue } from 'vue-property-decorator'; 
	import { moduloAdminService  }  from '@/servicegerente'; 
	import $ from "jquery" ;

	@Component({
		components: { 
        },
	 })
    export default class FormModuloDisciplinasAssuntos extends Vue { 
        @Prop( ) readonly assuntos!: any 
        @Prop( ) readonly disciplina!: any 
        @Prop( ) readonly modulo!: any 
        public assunto: any = null; 
        public prioridade: any = 5; 
        public add_assunto_id = 'modal-seguranca-modulo-adicionar-assunto'; 
 
        AdicionarPermissao() {
            if (this.assunto && this.prioridade  ) {

                window.alertProcessando();
                const dados = {
                    assunto :this.assunto, 
                    prioridade :this.prioridade, 
                    pivot_disciplina_id : this.disciplina.pivot, 
                    disciplina_id :  this.disciplina.id, 
                };   

                moduloAdminService.adicionarAssunto( this.modulo.id ,  dados )
                .then(response => {
                    window.toastSucesso("disciplina adicionado com successo.");
                    window.alertProcessandoHide();
                    this.$emit('assuntoAdicionado', response); 
                })
                .catch(error => { 
                    window.toastErro(error.message);
                    window.alertProcessandoHide();  
                    console.log(error);
                });   
            }
        } 

    }
 
 
